import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AccountActions } from '@core/states/account/account.actions';
import { Actions, ofActionSuccessful, Store } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { AppNavigation } from '@app/app.navigation';

const { LoginAccount, LogoutAccount, SetLogoutRedirect } = AccountActions;

@Injectable()
export class AccountEffects {
  constructor(
    private readonly router: Router,
    private readonly store: Store,
    private readonly actions$: Actions,
  ) {}

  init(): void {
    this.handleLogout();
    this.handleLogin();
  }

  private handleLogout(): void {
    this.actions$
      .pipe(
        ofActionSuccessful(LogoutAccount),
        tap(() => this.store.dispatch(new SetLogoutRedirect(true))),
        tap(() =>
          this.router
            .navigate([AppNavigation.Login])
            .then(() => this.store.dispatch(new SetLogoutRedirect(false)))
            .catch(() => this.store.dispatch(new SetLogoutRedirect(false))),
        ),
      )
      .subscribe();
  }

  private handleLogin(): void {
    this.actions$
      .pipe(
        ofActionSuccessful(LoginAccount),
        tap(() => this.router.navigate([AppNavigation.Dashboard])),
      )
      .subscribe();
  }
}
